export const studentSubjectApi = {
    heading:[
        {
            head:"Subject Name"
        },
    ],
    data:[
       {
        id:1,
        tickmark:false,
        subjectname:"English"

       },
       {
        id:2,
        tickmark:false,
        subjectname:"Math"

       },
       {
        id:3,
        tickmark:false,
        subjectname:"Physics"

       },
     
     
       
    ]
}